// ---------- small aggregation helpers shared by tx-flow components ----------

export const _sumLovelace = (rows) =>
  (rows || []).reduce(
    (acc, r) =>
      acc +
      BigInt(r.amount?.find?.((a) => a.unit === "lovelace")?.quantity || "0"),
    0n,
  );

export const _distinctAddrCount = (rows) =>
  new Set((rows || []).map((r) => r.address).filter(Boolean)).size;
